import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Message, MessageHandlerDisplayType, useAppDispatch, ConfigKeys } from "src/common";
import { DeveloperRoutes, DeveloperNavigationPath } from "src/common/developers";
import { DeveloperWrapper } from ".";
import { uiActions, getConfigValue } from "src/store";

interface FileInfo {
  name: string;
  type: string;
  coll_id: string;
  node_id: string;
  entry_state_tracker: string | null;
  local_node_info: string | null;
  user_root?: string;
}

function Diagnostic() {
  const { user_id, path } = useParams();
  const dispatch = useAppDispatch();
  const [files, setFiles] = useState<FileInfo[]>([]);
  const filesync_server = getConfigValue(ConfigKeys.filesync_server);
  const local_app_server = getConfigValue(ConfigKeys.local_app_server);

  useEffect(() => {
    if (!!user_id) {
      fetchDirectoryListing(user_id, path);
    } else {
      dispatch(uiActions.handleRequestErrors(new Message("User ID not set!", MessageHandlerDisplayType.toastr)));
    }
  }, []);

  const fetchDirectoryListing = (user_id: string, path?: string) => {
    const form_data = new FormData();
    form_data.append("uid", user_id);
    if (!!path) {
      form_data.append("path", path);
    }

    fetch(`${filesync_server}/diagnostics/files`, {
      method: "PUT",
      body: form_data,
    })
      .then((response) => response.json())
      .then((files_data: FileInfo[]) => {
        setFiles(files_data);
      })
      .catch((error) => {
        dispatch(uiActions.handleRequestErrors(new Message(error, MessageHandlerDisplayType.toastr), error));
      });
  };

  const renderFileRow = (file: FileInfo) => {
    const link_href = `${local_app_server}/developer/${DeveloperRoutes.diagnostics}/${encodeURIComponent(user_id || "").replace(
      /\+/g,
      "%2B"
    )}${encodeURIComponent(path || "").replace(/\+/g, "%2B")}/${encodeURIComponent(`${file.user_root}/${file.name}`)}`;

    return (
      <tr key={file.name}>
        <td>
          {file.type === "Directory" ? (
            <a href={link_href}>
              {file.name}
            </a>
          ) : (
            file.name
          )}
        </td>
        <td>{file.type}</td>
        <td>{file.coll_id}</td>
        <td>{file.node_id}</td>
        <td>{file.entry_state_tracker && Object.keys(file.entry_state_tracker).length > 0 ? "Yes" : "No"}</td>
        <td>{file.local_node_info && file.local_node_info !== "" ? "Yes" : "No"}</td>
      </tr>
    );
  };

  return (
    <DeveloperWrapper type={DeveloperNavigationPath.DefaultNavigation}>
      <div>
        <h1>Directory Listing</h1>
        <table className="diagnostics table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Collection ID</th>
              <th>Node ID</th>
              <th>Entry State Tracker</th>
              <th>Node Store</th>
            </tr>
          </thead>
          <tbody>
            {files.map(renderFileRow)}
          </tbody>
        </table>
      </div>
    </DeveloperWrapper>
  );
};

export default React.memo(Diagnostic);
